// extracted by mini-css-extract-plugin
module.exports = {"container":"Hero_container__o5U9L","heroText":"Hero_heroText__WQQCg"};